<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="订单日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-button size="medium" type="primary" :loading="loading" @click="doQueryTable">筛选</el-button>
          <el-button size="medium" :loading="loading" @click="createDocument">新增</el-button>
          <el-button size="medium" type="primary" plain :loading="loading" @click="Export">导出</el-button>
          <el-button size="medium" :loading="loading" @click="syncFormVisible = true">一键同步销售订单</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="日期" prop="INCOME_DATE" width="200"></el-table-column>
          <el-table-column label="净菜收入金额" prop="NET_DISH_INCOME_NUM"></el-table-column>
          <el-table-column label="净菜服务人数" prop="NET_DISH_PERSON_NUM"></el-table-column>
          <el-table-column label="毛菜收入金额" prop="GROSS_DISH_INCOME_NUM"></el-table-column>
          <el-table-column label="毛菜服务人数" prop="GROSS_DISH_PERSON_NUM"></el-table-column>
          <el-table-column label="成品菜收入金额" prop="INCOME_NUM"></el-table-column>
          <el-table-column label="成品菜服务人数" prop="PERSON_NUM"></el-table-column>
          <el-table-column label="操作" min-width="130">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="openEdit(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="deleteEdit(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增 -->
    <el-dialog :visible.sync="addFormDialog" title="新增" @close="close" width="650px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true" label-width="100px">
        <el-form-item label="日期：">
          <el-date-picker v-model="addForm.INCOME_DATE" type="date" :picker-options="pickerOptions" placeholder="选择日期"
            :clearable="true"></el-date-picker>
        </el-form-item>
        <el-form-item label="" style="margin-left:100px">
          <span>收入金额</span>
          <span style="margin-left:170px">服务人数</span>
        </el-form-item>
        <el-form-item label="净菜：">
          <el-input v-model="addForm.NET_DISH_INCOME_NUM" style="width:200px"></el-input>
          <el-input v-model="addForm.NET_DISH_PERSON_NUM" style="width:200px;margin-left:25px"></el-input>
        </el-form-item>
        <el-form-item label="毛菜：">
          <el-input v-model="addForm.GROSS_DISH_INCOME_NUM" style="width:200px"></el-input>
          <el-input v-model="addForm.GROSS_DISH_PERSON_NUM" style="width:200px;margin-left:25px"></el-input>
        </el-form-item>
        <el-form-item label="成品菜：">
          <el-input v-model="addForm.INCOME_NUM" style="width:200px"></el-input>
          <el-input v-model="addForm.PERSON_NUM" style="width:200px;margin-left:25px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="close">取消</el-button>
        <el-button class="operate-btn" @click="submitAdd">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :visible.sync="changeAddFormDialog" title="修改" @close="close" width="650px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true" label-width="100px">
        <el-form-item label="日期：">
          <el-date-picker v-model="addForm.INCOME_DATE" type="date" align="right" placeholder="选择日期" :clearable="true">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" style="margin-left:100px">
          <span>收入金额</span>
          <span style="margin-left:170px">服务人数</span>
        </el-form-item>
        <el-form-item label="净菜：">
          <el-input v-model="addForm.NET_DISH_INCOME_NUM" style="width:200px"></el-input>
          <el-input v-model="addForm.NET_DISH_PERSON_NUM" style="width:200px;margin-left:25px"></el-input>
        </el-form-item>
        <el-form-item label="毛菜：">
          <el-input v-model="addForm.GROSS_DISH_INCOME_NUM" style="width:200px"></el-input>
          <el-input v-model="addForm.GROSS_DISH_PERSON_NUM" style="width:200px;margin-left:25px"></el-input>
        </el-form-item>
        <el-form-item label="成品菜：">
          <el-input v-model="addForm.INCOME_NUM" style="width:200px"></el-input>
          <el-input v-model="addForm.PERSON_NUM" style="width:200px;margin-left:25px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="close">取消</el-button>
        <el-button class="operate-btn" @click="changeEdit">确认</el-button>
      </div>
    </el-dialog>
    <!-- 一键同步销售订单 -->
    <el-dialog :visible.sync="syncFormVisible" title="一键同步销售订单" @close="close" width="550px" center>
      <el-form ref="syncForm" v-model="syncForm" :inline="true" label-width="100px">
        <el-form-item label="日期范围：">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            v-model="syncForm.START_END" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="syncFormVisible = false">取消</el-button>
        <el-button class="operate-btn" @click="syncSellOrder">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      reportId: null,
      searchForm: {
        SEND_DAY: [],
      },
      addFormDialog: false,
      changeAddFormDialog: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      addForm: {
      },
      syncFormVisible: false,
      syncForm: {},
    };
  },
  computed: {
    CUSTOMER_LIST() {
      return this.$store.state.SAVE_CUSTOMER_LIST;
    },
  },
  methods: {
    // 新增
    createDocument() {
      this.addFormDialog = true;
    },
    IncomeNum(e) {
      this.addForm.INCOME_NUM = e;
    },
    PersonNum(e) {
      this.addForm.PERSON_NUM = e;
    },
    // 删除
    deleteEdit(row) {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 14,
        REPORT_ID: row.REPORT_ID,
      };
      http
        .post(params)
        .then((res) => {
          this.queryTable();
        })
        .catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    // 修改确认
    changeEdit() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!this.addForm.INCOME_DATE) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.INCOME_NUM)) {
        this.$message.show({ text: '请输入正数成品菜收入金额', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.PERSON_NUM)) {
        this.$message.show({ text: '请输入正数成品菜服务人数', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.GROSS_DISH_INCOME_NUM)) {
        this.$message.show({ text: '请输入正数毛菜收入金额', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.GROSS_DISH_PERSON_NUM)) {
        this.$message.show({ text: '请输入正数毛菜服务人数', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.NET_DISH_INCOME_NUM)) {
        this.$message.show({ text: '请输入正数净菜收入金额', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.NET_DISH_PERSON_NUM)) {
        this.$message.show({ text: '请输入正数净菜服务人数', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 15,
        REPORT_ID: this.reportId,
        INCOME_DATE: date(this.addForm.INCOME_DATE, '%F'),
        INCOME_NUM: Number(this.addForm.INCOME_NUM),
        PERSON_NUM: Number(this.addForm.PERSON_NUM),
        SMPPORT: 1,
        GROSS_DISH_INCOME_NUM: Number(this.addForm.GROSS_DISH_INCOME_NUM),
        GROSS_DISH_PERSON_NUM: Number(this.addForm.GROSS_DISH_PERSON_NUM),
        NET_DISH_INCOME_NUM: Number(this.addForm.NET_DISH_INCOME_NUM),
        NET_DISH_PERSON_NUM: Number(this.addForm.NET_DISH_PERSON_NUM),
      };
      http
        .post(params)
        .then((res) => {
          this.changeAddFormDialog = false;
          this.addForm = {};
          this.queryTable();
        })
        .catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    // 修改
    openEdit(row) {
      this.reportId = row.REPORT_ID;
      this.addForm = JSON.parse(JSON.stringify(row));
      this.changeAddFormDialog = true;
    },
    // 搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // ---------------------------分页
    handleChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    // -------------------拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 13,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.currentPage) {
        params.PAGE_INDEX = Number(this.currentPage - 1);
      }
      if (this.searchForm.SEND_DAY) {
        params.INCOME_DATE_START = date(this.searchForm.SEND_DAY[0], '%F');
        params.INCOME_DATE_END = date(this.searchForm.SEND_DAY[1], '%F');
      }
      if (this.pageSize) {
        params.PAGE_SIZE = Number(this.pageSize);
      }
      http
        .post(params)
        .then((res) => {
          if (res.length !== 0) {
            this.tableData = res[0].ansList;
            this.totalCount = res[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
        })
        .catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    submitAdd() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!this.addForm.INCOME_DATE) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.INCOME_NUM)) {
        this.$message.show({ text: '请输入正数成品菜收入金额', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.PERSON_NUM)) {
        this.$message.show({ text: '请输入正数成品菜服务人数', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.GROSS_DISH_INCOME_NUM)) {
        this.$message.show({ text: '请输入正数毛菜收入金额', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.GROSS_DISH_PERSON_NUM)) {
        this.$message.show({ text: '请输入正数毛菜服务人数', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.NET_DISH_INCOME_NUM)) {
        this.$message.show({ text: '请输入正数净菜收入金额', type: 'warning' });
        return false;
      }
      if (!reg.test(this.addForm.NET_DISH_PERSON_NUM)) {
        this.$message.show({ text: '请输入正数净菜服务人数', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 12,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        INCOME_DATE: date(this.addForm.INCOME_DATE, '%F'),
        INCOME_NUM: Number(this.addForm.INCOME_NUM),
        PERSON_NUM: Number(this.addForm.PERSON_NUM),
        SMPPORT: 1,
        GROSS_DISH_INCOME_NUM: Number(this.addForm.GROSS_DISH_INCOME_NUM),
        GROSS_DISH_PERSON_NUM: Number(this.addForm.GROSS_DISH_PERSON_NUM),
        NET_DISH_INCOME_NUM: Number(this.addForm.NET_DISH_INCOME_NUM),
        NET_DISH_PERSON_NUM: Number(this.addForm.NET_DISH_PERSON_NUM),
      };
      if (!this.addForm.INCOME_NUM || !this.addForm.PERSON_NUM || !this.addForm.GROSS_DISH_INCOME_NUM
        || !this.addForm.GROSS_DISH_PERSON_NUM || !this.addForm.NET_DISH_INCOME_NUM || !this.addForm.NET_DISH_PERSON_NUM) {
        this.$message.show({ text: '请填写完整信息', type: 'warning' });
        return false;
      }
      http
        .post(params)
        .then((res) => {
          this.addFormDialog = false;
          this.addForm = {};
          this.queryTable();
        })
        .catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    close() {
      this.addFormDialog = false;
      this.changeAddFormDialog = false;
    },
    Export() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 21,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SEND_DAY && this.searchForm.SEND_DAY[0]) {
        params.INCOME_DATE_START = this.searchForm.SEND_DAY[0];
        params.INCOME_DATE_END = this.searchForm.SEND_DAY[1];
      } else {
        this.$message.show({ text: '必须选择订单日期范围', type: 'warning' });
        return;
      }
      http
        .post(params)
        .then((res) => {
          if (res[0] && res[0].FILE_PATH) {
            window.location.href = res[0].FILE_PATH;
          } else {
            this.$message.show({ text: '暂无数据', type: 'warning' });
          }
        })
        .catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    // 一键同步销售订单
    syncSellOrder() {
      if (!this.syncForm.START_END) {
        this.$message.show({ text: '必须选择同步日期范围', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 20,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        START_DATE: this.syncForm.START_END[0],
        END_DATE: this.syncForm.START_END[1],
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '同步成功', type: 'success' });
        } else {
          this.$message.show({ text: res[0], type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT'))
      ? Number(localStorage.getItem('SMP_PAGE_COUNT'))
      : 10;
    // if (
    //   JSON.stringify(this.CUSTOMER_LIST) != "{}" &&
    //   this.CUSTOMER_LIST != undefined
    // ) {
    //   this.statusForm = this.CUSTOMER_LIST.CONDITION;
    //   this.currentPage = this.CUSTOMER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/incomeReport.vue